import { useEffect, useState } from 'react';

import { useCompanyHook } from '../../../Hooks/Companies/companyHooks';

import { AutoCompleteDropdownInterface } from '../../../Models/Common/FormFieldComponentInterfaces';

import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';

import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';
import { CompanyListField } from '../../../Utilities/Enums/ParametersEnum';

import AutoCompleteDropdown from '../AutoCompleteDropdown';

export default function CompanyDropdown(fieldProps: AutoCompleteDropdownInterface) {
	let {
		name,
		title,
		fieldValue,
		options,
		isLoadingDropdown,
		disabled,
		required,
		errorMessages,
		handleOnChange,
        hideLabel,
        fieldClassName,
        multiple,
	} = fieldProps;

	//Use States
    const [queryStr, setQueryStr] = useState({
        pageSize: 2000,
        // pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        // searchString: QueryBuilderHelper.DefaultSearchValue(),
    });

	const q_queryKey = [CachingEnum.COMPANY_LIST, queryStr]
    const { data, fetchStatus } = useCompanyHook(q_queryKey, queryStr);
    
    const companyProps = {
        name: name,
        title: title,
        fieldValue: fieldValue,
        options: data?.data?.list?.map((item: any) => { return { id: item?.[CompanyListField.PUBLIC_ID] ?? "", ...item  }}) ?? [], 
        isLoadingDropdown: fetchStatus == "fetching",
        disabled: disabled,
        required: required,
        hideLabel: hideLabel,
        errorMessages: errorMessages,
        handleOnChange: handleOnChange,
        fieldClassName: fieldClassName,
        multiple: multiple,
    };

    //Rendering Functions
    return <AutoCompleteDropdown {...companyProps} />
}
